import { ref } from "vue";

export type FillType = "filled" | "notFilled" | "preFilled" | "randomFull" | "randomColumn" | "";

const bettingMode = ref<string>("mainProductPage");
const bettingModePosition = ref<string | null>(null);
const initialBoardsCount = ref<number>(0);
const columnsFillState = ref<string>("notFilled");
const boardsFillTracking = ref<FillType[]>([]);

const setColumnsFillStateToPreFilled = () => {
    columnsFillState.value = "preFilled";
};

export default function usePpBetAnalytics() {
    return {
        bettingMode,
        bettingModePosition,
        initialBoardsCount,
        columnsFillState,
        boardsFillTracking,
        setColumnsFillStateToPreFilled,
    };
}
